import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
export function PainPoint() {
  return <section id="problema" className="py-14 bg-cream-50" data-id="element-214">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-215">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-216">
          <div className="flex justify-center mb-6" data-id="element-217">
            <FlameIcon className="h-10 w-10 text-terracotta-400" strokeWidth={1.5} data-id="element-218" />
          </div>

          <h2 className="text-sm font-bold tracking-widest text-olive-500 uppercase mb-8" data-id="element-219">
            La verdad que nadie en las tiendas te dice
          </h2>

          <div className="space-y-8 text-lg md:text-xl text-charcoal/80 leading-relaxed font-light" data-id="element-220">
            <p data-id="element-221">Cada año, las mujeres en Colombia gastan millones en ropa.</p>
            <p data-id="element-222">
              Y cada mañana, millones de mujeres abren un closet lleno…{' '}
              <span className="font-medium text-charcoal" data-id="element-223">
                y sienten que no tienen nada que ponerse.
              </span>
            </p>
            <p className="text-2xl font-display italic text-olive-600 my-12" data-id="element-224">
              ¿Por qué?
            </p>
            <p className="font-medium text-xl text-charcoal" data-id="element-225">
              Porque compramos prendas. No construimos imagen.
            </p>
            <p data-id="element-226">
              Compramos lo que está en promoción. Lo que está de moda. Lo que le
              quedó bien a la influencer. Lo que era barato ese día.
            </p>
            <p data-id="element-227">
              Y el resultado es un closet de cosas que no conectan entre sí, que
              no te quedan perfectas, que no te hacen sentir poderosa cuando más
              lo necesitas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}